<template>
  <router-view />
</template>

<script>
export default {
  name: "app-orderPositions"
};
</script>

<style lang="scss" scoped></style>
